import { RouteRecordRaw } from "vue-router";

const sidebarName = "SidebarProcessTracking";

export const processTrackingRoutes: RouteRecordRaw[] = [
  {
    path: "/process-tracking",
    component: () => import("@/views/common/Home.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/process-tracking/samplingpoints",
    component: () => import("@/views/processTracking/SamplingPointList.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/process-tracking/samplingpoints/gallery/",
    component: () => import("@/views/processTracking/GalleryEstimation.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/stations/new",
    component: () => import("@/views/processTracking/NewStations.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/process-tracking/upload",
    component: () => import("@/views/support/UploadData.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/process-tracking/trainingdata",
    component: () => import("@/views/admin/TrainingDataForm.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/process-tracking/downloadTrainingData",
    component: () => import("@/views/admin/downloadTrainingData.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },

  {
    path: "/process-tracking/samplingpoints/classificationImage",
    component: () => import("@/views/processTracking/ClassificationImage.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },

  {
    path: "/process-tracking/samplingpoints/classificationImage/imagelabel/",
    component: () => import("@/views/processTracking/ImageLabel.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/process-tracking/samplingpoints/samplingPointConfig",
    component: () => import("@/views/processTracking/SamplingPointConfig.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/process-tracking/samplingpoints/FQConfig",
    component: () => import("@/views/processTracking/SamplingPointFQConfig.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/process-tracking/uploadCsv",
    component: () => import("@/views/processTracking/uploadCsv.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
];
